import { fontClass, renderWithPersianFont } from 'i18n';
import { Form, Select } from 'antd';

export default function BasicSelect({
  options,
  name,
  label,
  width,
  classes,
  isDefault,
  onSelectChange,
  rules = false,
  message = null,
  popup,
  disabled,
  defaultValue,
  labelClassName,
  testIds,
  allowclear,
  showSearch,
  mode,
}) {
  const { Option } = Select;

  return (
    <Form.Item
      className={classes || 'flex flex-col font-bold'}
      rules={[
        { required: rules, message: message ? message : `${name} is required` },
      ]}
      name={name}
      label={<label className={labelClassName}>{label}</label>}
    >
      <Select
        allowClear={allowclear}
        showSearch={showSearch}
        data-testid={testIds?.main}
        disabled={disabled}
        optionFilterProp="label"
        onChange={onSelectChange}
        defaultValue={
          isDefault ? options[0] : '' || defaultValue ? defaultValue : ''
        }
        bordered={false}
        style={{ width: width || '100%' }}
        className="bg-[#EEF0F2]  text-[#5B6268] rounded-lg "
        mode={mode}
      >
        {options?.map((option, i) => {
          return (
            <Option
              data-testid={`${testIds?.main}:${option?.value}`}
              key={i}
              value={option?.value}
              label={option?.title}
            >
              {renderWithPersianFont(option?.title, fontClass)}
            </Option>
          );
        })}
      </Select>
    </Form.Item>
  );
}